import React from "react";
import Storage from "./Components/Storage";
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
  return (
    <div>
      <Storage />
    </div>
  );
};

export default App;
